<template>
  <div id="app">
    <head>
      <meta charset="utf-8">
      <meta http-equiv=“Content-Type” content=“text/html; charset=utf-8”>
<!--      <link href="https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js" rel="stylesheet">-->
      <meta name="google-signin-client_id" content="837325808921-dbdq54qf1qu3g9bv4athdovbb8a57t4o.apps.googleusercontent.com">
      <link href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900" rel="stylesheet">
      <link href="https://cdn.jsdelivr.net/npm/@mdi/font@4.x/css/materialdesignicons.min.css" rel="stylesheet">
      <link href="https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css" rel="stylesheet">
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, minimal-ui">
    </head>
    <sidebar-menu :collapsed="true" v-show="authenticatedUser"
      style="position: fixed;
      top: 80px;
      height: calc(100% - 80px);
      width: 16%;
      min-width: 72px;"
      :menu="menu"/>
    <Navbar v-bind:project="project"></Navbar>
    <router-view/>
    <Footer v-bind:project="project"></Footer>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Vuetify from 'vuetify'

export default {
  name: 'app',
  vuetify: new Vuetify(),
  components: {
    Navbar,
    Footer
  },
  data () {
    return {
      project: {
        'brandName': 'CultureLabs',
        'baseUrl': 'https://culture-labs.eu',
        'apiUrl': 'https://api.culture-labs.eu'
      },
      menu: [
        {
          header: true,
          title: 'Main Navigation',
          hiddenOnCollapse: true
        },
        {
          href: '/',
          title: 'Home',
          icon: 'fa fa-home'
        },
        {
          href: '/workspace/recipes',
          title: 'Recipes',
          icon: 'fa fa-concierge-bell'
        },
        {
          href: '/workspace/resources',
          title: 'Ingredients',
          icon: 'fa fa-utensils'
        },
        {
          href: '/workspace/organizations',
          title: 'Organisations',
          icon: 'fa fa-building'
        },
        // {
        //   header: true,
        //   title: 'Other',
        //   hiddenOnCollapse: false
        // },
        {
          href: '/workspace/groups',
          title: 'Groups',
          icon: 'fa fa-users'
        },
        {
          href: '/workspace/bookmarks',
          title: 'Bookmarks',
          icon: 'fa fa-star'
        }
        // {
        //   href: '/workspace/account',
        //   title: 'My profile',
        //   icon: 'fa fa-user'
        // }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'authenticatedUser'
    ])
  }
}
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
    background-color: #f7f7f7;
  }

  .btn-danger, .btn-info, .btn-dark, .btn-success, .btn-secondary {
    color: #fff !important;
  }

  .vsm--icon {
    width: 50px !important;
    height: 50px !important;
    vertical-align: center !important;
    padding: 10px !important;
  }
  .vsm--title {
    padding: 10px !important;
    font-size: 18px !important;
  }
  div.mdl-layout__drawer > nav.mdl-navigation > a.mdl-navigation__link {
    display: inline-flex !important;
    vertical-align: middle !important;
  }

  .bg-gray {
    background-color: white !important;
    border: 0 !important;
    border-bottom: 1px #ccc solid !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue